function fixSafariAccordionLinks() {
  // Safari hotfix, it doesn't like links in accordion summaries
  // https://aworldforus.slack.com/archives/C06NPQQ8FSS/p1719930206325459
  if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
    document.querySelectorAll("details summary a").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        if (link.getAttribute("target") == "_blank") {
          window.open(link.href);
          return;
        }

        window.location.href = link.href;
      });
    });
  }
}

export function initPolyfills() {
  fixSafariAccordionLinks();
}
